import React, { FC } from 'react'
import { LeftContent, RightContent, StyledCol, StyledNav } from '../Navigation'
import { FullPageGrid } from '@epidemicsound/design-system'
import { Link } from '../../link/Link'
import { Menu } from './Menu'
import { usePageMode, smallScreenWidth } from 'hooks/hooks'
import { DevelopersLogo } from '../../logo/DevelopersLogo'
import styled from 'styled-components'
import { useSession } from 'next-auth/react'

const StyledPortalNav = styled.div`
    .portal-navigation-grid {
        background-color: #0f0f0f;
    }

    @media only screen and (max-width: ${smallScreenWidth + 'px'}) {
        .portal-navigation-grid {
            width: 96%;
            margin: 0;
            padding: 0;
        }
    }
`

interface PortalNavigationProps {
    isAuthenticated: boolean
}

export const PortalNavigation: FC<PortalNavigationProps> = ({
    isAuthenticated,
}) => {
    const { data: session } = useSession()
    const { pageMode } = usePageMode()

    return (
        <StyledPortalNav>
            <StyledNav>
                <FullPageGrid className={'portal-navigation-grid'}>
                    <StyledCol size={12}>
                        <LeftContent>
                            {(isAuthenticated &&
                                pageMode === 'View' &&
                                session && (
                                    <Link
                                        to={{
                                            path: '/partners/[id]/dashboard',
                                            url: `/partners/${session.partner.id}/dashboard`,
                                        }}
                                        app={'DevPortal'}
                                    >
                                        <DevelopersLogo />
                                    </Link>
                                )) || <DevelopersLogo />}
                        </LeftContent>
                        <RightContent>
                            {isAuthenticated && pageMode === 'View' && <Menu />}
                        </RightContent>
                    </StyledCol>
                </FullPageGrid>
            </StyledNav>
        </StyledPortalNav>
    )
}
